import React from "react";
import { Link } from "react-router-dom";
import Container from "../hoc/Container";
import { OPERATOR, PRIVACY_PATH, SITE_URL } from "../legal/operator";
import { List, MailLink, Section } from "../legal/policyBlocks";

function ConsentPage() {
  return (
    <Container>
      <section className="main-content-block">
        <h1 className="main-title">Согласие на обработку персональных данных</h1>
        <div className="offer-text policy-text">
          <p className="policy-operator">
            Оператор персональных данных — {OPERATOR.fullName}, ИНН{" "}
            {OPERATOR.inn}, ОГРНИП {OPERATOR.ogrnip}, регистрационный номер в
            реестре операторов {OPERATOR.registryNumber}.
          </p>
          <p>
            Я свободно, своей волей и в своём интересе даю согласие указанному
            выше оператору (далее — Оператор) на обработку моих персональных
            данных на условиях, изложенных ниже.
          </p>
          <p>
            Согласие я даю одним из способов: отмечаю поле «Я даю согласие
            на обработку персональных данных» в форме заказа или при создании
            личного кабинета на сайте{" "}
            <Link className="policy-link" to="/">
              {SITE_URL}
            </Link>{" "}
            либо нажимаю кнопку «Даю согласие на обработку персональных данных» в
            Telegram-боте магазина.
          </p>

          <Section id="purposes" title="1. Цели обработки">
            <List
              items={[
                "оформление и выполнение заказов, выдача приобретённых кодов, пополнение аккаунта Steam;",
                "поддержка пользователя по вопросам заказов;",
                "ведение личного кабинета: вход по коду на почту, показ моих заказов и кодов, хранение избранных игр — если я его создаю;",
                "сбор статистики использования сайта в обезличенном виде.",
              ]}
            />
          </Section>

          <Section id="data" title="2. Персональные данные">
            <List
              items={[
                "адрес электронной почты;",
                "логин аккаунта Steam (при пополнении Steam);",
                "имя и идентификатор пользователя в Telegram (при оформлении заказа через бота);",
                "история заказов;",
                "список избранных игр — если я веду личный кабинет;",
                "дата и время создания личного кабинета и входа в него — если я его создаю;",
                "IP-адрес, файлы cookie, сведения о браузере и устройстве.",
              ]}
            />
          </Section>

          <Section id="actions" title="3. Действия с данными">
            <p>
              Сбор, запись, систематизация, накопление, хранение, уточнение
              (обновление, изменение), извлечение, использование, передача
              (предоставление, доступ) лицам, которые оказывают Оператору
              услуги и перечислены в Политике обработки персональных данных,
              обезличивание, блокирование, удаление и уничтожение. Обработка
              ведётся с использованием средств автоматизации. Данные хранятся
              на территории Российской Федерации.
            </p>
          </Section>

          <Section id="term" title="4. Срок действия и отзыв">
            <p>
              Согласие действует до достижения целей обработки или до его
              отзыва. Отозвать согласие можно, направив письмо на <MailLink />{" "}
              с темой «Персональные данные». После отзыва Оператор прекращает
              обработку и уничтожает данные в срок не более 30 дней, если
              иное не предусмотрено законом.
            </p>
          </Section>

          <p>
            Я ознакомлен с{" "}
            <Link className="policy-link" to={PRIVACY_PATH}>
              Политикой обработки персональных данных
            </Link>
            .
          </p>
        </div>
      </section>
    </Container>
  );
}

export default ConsentPage;
